import { AtlasPlatformState } from "./types";

export const defaultState = (): AtlasPlatformState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    atlasPlatforms: [],
    links: {}
  };
};

export const state = defaultState();
